import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  OrderType,
  SetDeliveryToDropOrdersType,
  SetOrdersActionType,
  SetSelectedCompanyType,
  SetSelectedOrderType,
} from './orders.types'
import { initialState, orderMock } from './orders.fixtures'

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrderType: (state, action: PayloadAction<OrderType>) => {
      state.selectedOrderTab = action.payload
    },
    setOrders: (state, action: PayloadAction<SetOrdersActionType>) => {
      const { orders, type } = action.payload

      switch (type) {
        case 'NEW':
          state.newOrders = orders
          break
        case 'ACTIVE':
        case 'ASSIGNED':
          state.activerOrders = orders
          break
        case 'ARCHIVED':
        case 'DELIVERED':
          state.archivedOrders = orders
          break
      }
    },

    setSelectedOrder: (state, action: PayloadAction<SetSelectedOrderType>) => {
      state.selectedOrder = action.payload.selectedOrder
    },

    setIsSelectedOrderLoading: (state, action: PayloadAction<boolean>) => {
      state.isSelectedOrderLoading = action.payload
    },

    clearSelectedOrder: (state) => {
      state.selectedOrder = orderMock
      state.isSelectedOrderLoading = false
    },

    setSelectedCompany: (
      state,
      action: PayloadAction<SetSelectedCompanyType>
    ) => {
      state.selectedCompany = action.payload.selectedCompany
    },

    setDeliveryToDropOrders: (
      state,
      action: PayloadAction<SetDeliveryToDropOrdersType>
    ) => {
      state.deliveryToDrop = action.payload.orders

      state.newOrders = state.newOrders.map((order) => ({
        ...order,
        orderEvents: order?.orderEvents.filter(
          (orderEvent) => orderEvent.eventType !== 'DELIVERY'
        ),
      }))
    },
  },
})

export const {
  setOrderType,
  setOrders,
  setSelectedOrder,
  setIsSelectedOrderLoading,
  clearSelectedOrder,
  setSelectedCompany,
  setDeliveryToDropOrders,
} = ordersSlice.actions

export default ordersSlice.reducer
